// src/config.js
// const BASE_URL = "http://bioalign.sandboxtrial.com";
const BASE_URL = "https://bioalign.lk";

export default BASE_URL;
